import { Controller } from "@hotwired/stimulus"

// Keeps a plain (data-turbo="false") form's hidden authenticity_token current.
//
// The hidden field is only as fresh as the HTML it came in; the
// `authenticity_token` cookie is refreshed on every response (CsrfTokenCookie).
// Turbo already reads that cookie for its own submissions, but a plain form
// posts whatever was rendered, so a tab left open past a session change is
// rejected with 422. Rewriting the field from the cookie right before the
// submit — in the capture phase, ahead of any other submit handler on the
// form — posts the token the session currently accepts.
//
//   <form data-turbo="false" data-controller="csrf-refresh"
//         data-action="submit->csrf-refresh#refresh:capture">
export default class extends Controller {
  static TOKEN_FIELD = "authenticity_token"

  connect() {
    this.refresh()
  }

  refresh() {
    const token = this.cookieToken()
    if (!token) return

    const field = this.element.querySelector(`input[name="${this.constructor.TOKEN_FIELD}"]`)
    if (field) field.value = token
  }

  cookieToken() {
    const prefix = `${this.constructor.TOKEN_FIELD}=`
    const row = document.cookie.split("; ").find((cookie) => cookie.startsWith(prefix))
    return row ? decodeURIComponent(row.slice(prefix.length)) : null
  }
}
